// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1MTk9","inputs":"styles_inputs__96V7T"};